import { FC } from 'react';
import ReserveFrameRegist from './ReserveFrameRegist';
import UseReserveFrameRegist from './UseReserveFrameRegist';

const ReserveFrameRegistContainer: FC = () => {
  return <ReserveFrameRegist {...UseReserveFrameRegist()} />;
};

export default ReserveFrameRegistContainer;
